<template>
<div>
  <div class="table-wrapper on-767"  v-if="$i18n.locale=='en'">
    <div class="custom-table governance directors-meeting" data-aos="fade-up">
        <div class="table-heading">Board Risk Committee Meetings:</div>
        <div class="trow head border-0 bg-green">
            <div class="th ">NAME </div>
            <div class="th text-center">MEETING no. 1/2020<br> 12/2/2020</div>
            <div class="th text-center">MEETING No. 2/2020<br>15/7/2020</div>
            <div class="th text-center">MEETING No. 3/2020<br>2/11/2020</div>
        </div>
        <div class="trow">
            <div><strong>Talal Said Al Mamari</strong><br>(Committee Chairman)</div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>Bader Nasser Al-Kharaf</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>Atif Said Rashid Al-Siyabi</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>Yousef Khaled Al-Abdulrazzaq</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="table-heading b-top-0">Previous Members</div>
        <div class="trow">
            <div><strong>Saud Al Nahari</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
        </div>
        <div class="trow grey percentage">
            <div><strong>Percentage of Members in Attendance</strong></div>
            <div class="text-center"><strong>100%</strong></div>
            <div class="text-center"><strong>100%</strong></div>
            <div class="text-center"><strong>100%</strong></div>
        </div>
    </div>
    </div>

    <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
    <div class="custom-table governance directors-meeting" data-aos="fade-up">
        <div class="table-heading">اجتماعات لجنة المخاطر</div>
        <div class="trow head border-0 bg-green">
            <div class="th ">اسم العضو</div>
            <div class="th text-center">اجتماع رقم 2020/1<br> 2020/2/12</div>
            <div class="th text-center">اجتماع رقم 2020/2<br>2020/7/15</div>
            <div class="th text-center">اجتماع رقم 2020/3<br>2020/11/2</div>
        </div>
        <div class="trow">
            <div><strong>طلال سعيد المعمري<br> (رئيس اللجنة)</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>بدر ناصر الخرافي</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>عاطف بن سعيد بن راشد السيابي</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>يوسف خالد العبد الرزاق</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="table-heading b-top-0">عضو سابق</div>
        <div class="trow">
            <div><strong>سعود النهاري</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
        </div>
        <div class="trow grey percentage">
            <div><strong>نسبة الحضور </strong></div>
            <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
            <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
            <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
        </div>
    </div>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>